/**
 * @fileoverview Paint-reference helper for donut slice gradients, paired
 * with the DonutSliceGradients defs component.
 * @module shared/utils/donutGradient
 */

/** Returns the SVG paint reference for slice `index` under `idPrefix`. */
export function donutSliceGradientFill(idPrefix: string, index: number): string {
  return `url(#${idPrefix}-${index})`
}
